/* eslint-disable no-nested-ternary */
import { getDY_SR } from "stackerConfig"
import { shadowDOM } from "components/Stacker/utils/shadowDOM"
import { globalLL } from "components/DYStackers/LegacyI18n"

export const arrayEquals = (a, b) => {
  const test = a.every((val, index) => {
    return val === b[index]
  })
  return test
}

export const getIsMensExperience = () => false
//  Commenting as this feature doesn't work
//  `${window.location.search}`
//    .split("&")
//    .some((s) => s.includes("stacker-experience=mens"))

export const getMensButtonStyles = () => ({
  color: "rgb(255,255,255)",
})

let bodyElement = null
const isIpad =
  navigator.userAgent.match(/Mac/) &&
  navigator.maxTouchPoints &&
  navigator.maxTouchPoints > 2

export const switchBodyToMens = () => {
  bodyElement = bodyElement || shadowDOM.querySelector("body")
  bodyElement.className = bodyElement.className.replace(/\bwomen\b/, "men")
  if (!bodyElement.className.includes("men")) {
    bodyElement.className = `${bodyElement.className} men`
  }
}

// This code will be executed many times during rendering, and should not be slow.
// Because this is developed and deployed independent of AEM changes, we need to assume the classnames on body are not correct.
const alwaysRemoveStackerClasses = ["default", "ShoppingBagPageBody"]
export const ensureStackerStyles = () => {
  bodyElement = bodyElement || shadowDOM.querySelector("body")
  const isMen = getIsMensExperience()
  const classes = ["StackerPageBody", isIpad && "stacker-ipad"].filter((c) => c)
  /*classes.forEach((c) => {
    if (!new RegExp(`\\b${c}\\b`, "ig").test(bodyElement.className))
      bodyElement.className = `${bodyElement.className} ${c}`
  })
  const removeStackerClasses = alwaysRemoveStackerClasses.concat([
    isMen && "women",
    !isMen && "men",
  ])
  removeStackerClasses.forEach((c) => {
    bodyElement.className = bodyElement.className.replace(
      new RegExp(`\\b${c}\\b`, "ig"),
      ""
    )
  })*/
  if (bodyElement.className.trim() !== bodyElement.className) {
    bodyElement.className = bodyElement.className.trim()
  }
}

export const getStackerLabel = (selector, ...replaceVars) => {
  if (!globalLL.bracelets) {
    return replaceVars
  }
  return globalLL.bracelets[selector]()
  // const stacker =
  //   getDY_SR().config.amuletStacker || getDY_SR().config.braceletStacker
  // let out = stacker.labels[selector]
  // replaceVars.forEach((replaceVar) => {
  //   out = out.replace(/{}/, replaceVar)
  // })
  // return out
}

// Creadit: Andrey Sitnik - https://github.com/ai/nanoid
// (Even though it appears to be copy/paste/modify of MDN code)
export const nanoid = (t = 8) => {
  let e = ""
  const r = crypto.getRandomValues(new Uint8Array(t))
  for (let i = t; i--; i >= 0) {
    // eslint-disable-next-line no-bitwise
    const n = 63 & r[i]
    e +=
      n < 36
        ? n.toString(36)
        : n < 62
        ? (n - 26).toString(36).toUpperCase()
        : n < 63
        ? "_"
        : "-"
  }
  return e
}
